export default __webpack_public_path__ + "static/media/17.f6a097e0.jpg";